import {IntermediatePart} from "../../intermediatePart";

export default class ToiletBrush extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'toilet_brush';
    this.partName = 'Toilet Brush';
    this.translateId = "visualizer.bathroom.accessories.toilet_brush";
    this.canBeDisabled = true;
  }
}
